module.exports = __webpack_public_path__ + "static/media/dicas-voala.918d03f5.jpg";